
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/venues/[id]",
      function () {
        return require("private-next-pages/venues/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/venues/[id]"])
      });
    }
  